export const FORMS_LOADED = "forms/formsLoaded"
export const FORM_UPDATED = "forms/formAdded"
export const BLOCK_ADDED = "forms/blockAdded"
export const BLOCK_DELETED = "forms/blockDeleted"
export const FORM_DELETED = "forms/formDeleted"